import { useJob } from '../../fetchers';
import { useCallback, useState } from 'react';
import styled from 'styled-components6';
import {
    CloseSVG,
    getPageUrl,
    H6,
    MediaImageGallery,
    MediaModalPortal,
    PhotoCount,
    useAnalyticsClickEvent,
    useAnalyticsViewEvent,
} from 'rwl-ui';
import { ClickTargets, ViewTargets } from 'rwl-shared/dist/models/analytics';

const ModalRefContainer = styled.div`
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;

const ModalContainer = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    background-color: black;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    bottom: 0;
    width: 100%;
`;

const HeaderContainer = styled.header`
    height: var(--rwl-header-height);
    display: flex;
    background-color: black;
    width: 100%;
    color: white;
`;

const CloseButtonContainer = styled.div`
    position: absolute;
    right: 0;
    margin: var(--rwl-spacing-md);
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: var(--rwl-radius-lg);
    padding: calc(var(--rwl-spacing-sm) / 2) var(--rwl-spacing-md);

    &:hover {
        background-color: var(--rwl-palette-gray-800);
    }
`;

export const MediaDetailsModal = (): JSX.Element => {
    const { job, setSelectedMedia, selectedMedia } = useJob();
    const [mediaIndex, setMediaIndex] = useState<number>(0);
    const widgetRoot = document.getElementById('widget-content');
    const sendViewEvent = useAnalyticsViewEvent();
    const sendClickEvent = useAnalyticsClickEvent();
    const onViewMedia = useCallback(
        (mediaId) => {
            sendViewEvent({
                url: getPageUrl(),
                target: ViewTargets.MEDIA_FULL,
                content: mediaId,
            });
        },
        [selectedMedia]
    );
    const onChange = useCallback(
        (media: any, index: number) => {
            setSelectedMedia(media);
            setMediaIndex(index);
            sendClickEvent({
                url: getPageUrl(),
                target:
                    index < mediaIndex ? ClickTargets.PREV : ClickTargets.NEXT,
                content: selectedMedia?.id,
            });
        },
        [selectedMedia, mediaIndex]
    );
    return (
        <ModalRefContainer>
            <MediaModalPortal
                isOpen={!!selectedMedia}
                onClose={() => setSelectedMedia(undefined)}
                container={widgetRoot}
            >
                <ModalContainer>
                    {selectedMedia && (
                        <>
                            <HeaderContainer>
                                <div
                                    style={{
                                        flex: 1,
                                        position: 'absolute',
                                        width: '100%',
                                    }}
                                >
                                    <PhotoCount
                                        mediaCount={job?.media?.length}
                                        mediaIndex={mediaIndex}
                                    />
                                </div>
                                <CloseButtonContainer
                                    onClick={() => {
                                        sendClickEvent({
                                            url: getPageUrl(),
                                            target: ClickTargets.CLOSE,
                                        });
                                        setSelectedMedia(undefined);
                                    }}
                                >
                                    <CloseSVG />
                                    <H6
                                        style={{
                                            color: 'var(--rwl-text-alternative)',
                                            fontWeight: '500',
                                            marginLeft: 'var(--rwl-spacing-sm)',
                                        }}
                                    >
                                        Close
                                    </H6>
                                </CloseButtonContainer>
                            </HeaderContainer>
                            <MediaImageGallery
                                onViewMedia={onViewMedia}
                                onChange={onChange}
                                media={selectedMedia}
                                allMedia={job?.media || []}
                                setMediaIndex={setMediaIndex}
                                mediaIndex={mediaIndex}
                                caption={selectedMedia?.caption}
                            />
                        </>
                    )}
                </ModalContainer>
            </MediaModalPortal>
        </ModalRefContainer>
    );
};
